import { createClient } from "@supabase/supabase-js"

const supabaseUrl = "https://sfkskwxjlhnlumllxebu.supabase.co"
const supabaseKey =
 "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNma3Nrd3hqbGhubHVtbGx4ZWJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5NzcwNTQsImV4cCI6MjA2NTU1MzA1NH0.OUCwZ-cXYYpPYidl-GbhQ3BvS50F6-HTIhv-kNptK-k"
export const supabase = createClient(supabaseUrl, supabaseKey)
